import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { AppStorageService, RecentOrderLogic } from '@mwe/services';
import { DataChangeType, NavigateToType, RecentOrder, RecentOrderType } from '@mwe/models';

@Component({
  selector: 'mwe-navigateto',
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigateToComponent implements OnInit {
  private appStorage = inject(AppStorageService);
  private route = inject(ActivatedRoute);
  private recentOrderLogic = inject(RecentOrderLogic);

  ngOnInit(): void {
    this.appStorage.clear();
    this.navigateTo(this.route.snapshot.queryParamMap);
  }

  navigateTo(paramMap: ParamMap): void {
    const navigateToType = this.route.snapshot.queryParamMap.get('navigateTo') as NavigateToType;
    const recentOrderType: string = paramMap.get('recentOrderType');
    const recentOrderId: string = paramMap.get('recentOrderId');
    const recentOrderIDCDataType: string = paramMap.get('recentOrderIDCDataType');
    switch (navigateToType) {
      case NavigateToType.recentOrderStatus:
        this.recentOrderLogic.navigateToOrderDetails({
          id: Number(recentOrderId),
          type: recentOrderType as RecentOrderType,
          dataType: recentOrderIDCDataType as DataChangeType,
        } as RecentOrder);
        break;
    }
  }
}
